import React from 'react'
import { useModal } from '@mprolab/uikit'
import _ from 'lodash'
import AwaitingWalletVerificationModal from './AwaitingWalletVerificationModal'

export interface ReturnType {
  onPresentAwaitingVerificationModal: () => void
  onModalClose: (success?: boolean) => void
}

export interface WalletVerificationModalProps {
  onVerificationCallback?: (success: boolean) => void
}

const useAwaitingWalletVerificationModal = ({ onVerificationCallback }: WalletVerificationModalProps): ReturnType => {
  const [onPresentAwaitingVerificationModal, onDismiss] = useModal(
    <AwaitingWalletVerificationModal
      onVerificationDeclined={() => {
        if (onVerificationCallback) onVerificationCallback(false)
      }}
    />,
    false
  )

  const onModalClose = (success?: boolean) => {
    onDismiss()
    if (!_.isNil(success) && onVerificationCallback) onVerificationCallback(success)
  }

  return { onPresentAwaitingVerificationModal, onModalClose }
}

export default useAwaitingWalletVerificationModal
